import React, { useEffect, useState } from 'react'
import moment from "moment";
import { getFormattedTime } from "../helpers/getFormattedTime";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Fragment, useId } from "react";
import { isEmptyObj } from '../helpers/commonHelper';
function getValidatingNameAndImage(flightDetails, carrier) {
  try {
    let item = flightDetails.find(fdetail => fdetail.Code === carrier);
    if (!isEmptyObj(item)) {
      return { name: item.Name + " (" + item.Code + ")", imageURL: item.Logo }
    }
    else return { name: flightDetails[0].Name, imageURL: flightDetails[0].Logo }
  }
  catch {
    return { name: "", imageURL: "" };
  }
}
const FlightListIndividualItem = ({ flight, array, carrier, isManual }) => {
  const identity = useId();
  const { name, imageURL } = getValidatingNameAndImage(flight.FlightDetails, carrier)

  return (
    <Fragment key={"Key_" + identity}>
      <div className="col-span-4 md:col-span-1 mb-2 lg:m-0">
        <p className="font-medium text-muted-foreground text-2xs md:text-2xs uppercase my-2 md:mt-0 tracking-wide">
          {array.length > 1
            ? array[0] == flight
              ? "Departure"
              : "Return"
            : "One Way"}
        </p>
        <div className="flex items-center gap-2">
          <img
            src={imageURL}
            className="w-8 h:8 md:w-12 md:h-12 rounded object-contain"
          />
          <div className="flex flex-col items-start justify-start ">
            <h2 className="font-medium text-sm md:text-md text-muted-foreground md:text-foreground">
              {isManual ? "⋆ " : ""}{name}
            </h2>
          </div>
        </div>
      </div>
      <div className="flex md:items-center md:justify-self-center">
        <div key={flight.DepartureDateTime} className="md:text-center">
          <p className="font-medium">
            {moment(flight.DepartureDateTime).format("LT")}
          </p>
          <div className="text-muted-foreground text-xs">
            <span className="text-muted-foreground">{flight.Origin}</span>
            <span className="mx-1 text-muted-foreground inline-flex">•</span>
            <span className="text-muted-foreground">
              {moment(flight.DepartureDateTime).format("ll")}
            </span>
          </div>
        </div>
      </div>
      <div className="flex col-span-2 items-center justify-self-center text-center md:col-span-1 text-muted-foreground">
        <div>
          <h3 className='text-xs'>{getFormattedTime(flight.ElapsedTime)}</h3>
          <div className="relative flex items-center justify-center h-2 md:h-4 text-center *:absolute z-0">
            <hr className="w-full " />
            <div className="flex gap-x-2">
              {flight.FlightDetails &&
                flight.FlightDetails.length > 0 &&
                flight.FlightDetails.map((fd, i) => {
                  if (flight.FlightDetails.length > i + 1)
                    return (
                      <TooltipProvider key={"tt_" + i}>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <span className="block text-lg cursor-pointer">
                              •
                            </span>
                          </TooltipTrigger>
                          <TooltipContent className="bg-gray-950 text-white border-none shadow-none">
                            <p>
                              {fd.ArrivalAirport.Code} estimated{" "}
                              {getFormattedTime(fd.ElapsedTime)}
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    );
                })}
              {/* <span className="block text-lg">•</span>
            <span className="block text-lg">•</span> */}
            </div>
          </div>
          {flight.FlightDetails.length > 1 ? (
            <h3 className='text-xs'>
              {flight.FlightDetails.length - 1 == 1
                ? "1 Stop"
                : flight.FlightDetails.length - 1 + " Stops"}
            </h3>
          ) : (
            <h3 className='text-xs'>Non-Stop</h3>
          )}
        </div>
      </div>
      <div className="flex md:items-center md:justify-self-center md:text-center">
        <div key={flight.ArrivalDateTime}>
          <p className="font-medium">
            {moment(flight.ArrivalDateTime).format("LT")}
          </p>

          <div className="text-muted-foreground text-xs">
            <span key={flight.Destination}>{flight.Destination}</span>
            {/* <span className="mx-1 text-muted-foreground inline-flex">•</span>

              <span className="text-muted-foreground">
                {moment(od.ArrivalDateTime).format("ll")}
              </span> */}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default FlightListIndividualItem
